<section class="progress-bar">
  <div class="progress-bar__container color-background-darker">
    <header class="progress-bar__header">
      <span class="progress-bar__label">{{ combinedText }}</span>
    </header>
    <div class="progress-bar__track">
      <div class="progress-bar__fill" [style.width.%]="progressValue"></div>
    </div>
  </div>
</section>
